import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { AppProviders } from './providers/AppProviders';

// Load order matters: tokens declare the variables, Tailwind's preflight lands next, and
// base.css comes last so its form-control and body rules win over preflight.
import './styles/tokens.css';
import './styles.css';
import './styles/base.css';

const twa = window.Telegram?.WebApp;
if (twa) {
  twa.ready();
  twa.expand();
}

const qc = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 30 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
      // Offline: keep serving what's cached rather than tearing the screen down.
      networkMode: 'offlineFirst',
    },
    mutations: { networkMode: 'offlineFirst' },
  },
});

const root = document.getElementById('root');
if (!root) throw new Error('No #root element');

createRoot(root).render(
  <StrictMode>
    {/*
      Outermost on purpose. A boundary inside the providers cannot catch a provider that throws,
      and the providers are where app-wide state lives — which is exactly the state a bad cache
      write corrupts. Outside them, nothing in the tree can produce a blank screen.
    */}
    <ErrorBoundary>
      <QueryClientProvider client={qc}>
        <BrowserRouter>
          <AppProviders>
            <App />
          </AppProviders>
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
);
